import styles from './styles.scss';
import { WHITE, PRIMARY, SECONDARY, TERTIARY, MAIN } from './constants';

const COLOR_WHITE = '#fff';
const COLOR_MAIN = '#333';

export const getForegroundColor = (foregroundColor, context) => {
  let foregroundClass;
  let foregroundHex;

  const {
    primaryColor,
    secondaryColor,
    tertiaryColor,
    primaryColorClass,
    secondaryColorClass,
    tertiaryColorClass,
  } = context;

  switch (foregroundColor) {
    case WHITE:
      foregroundClass = styles.colorWhiteForeground;
      foregroundHex = COLOR_WHITE;
      break;
    case MAIN:
      foregroundClass = styles.colorMainForeground;
      foregroundHex = COLOR_MAIN;
      break;
    case PRIMARY:
      foregroundClass = primaryColorClass;
      foregroundHex = primaryColor;
      break;
    case SECONDARY:
      foregroundClass = secondaryColorClass;
      foregroundHex = secondaryColor;
      break;
    case TERTIARY:
      foregroundClass = tertiaryColorClass;
      foregroundHex = tertiaryColor;
      break;
    default:
      foregroundClass = styles.colorMainForeground;
      foregroundHex = COLOR_WHITE;
      break;
  }

  return { foregroundClass, foregroundHex };
};

export const getBackgroundColor = (backgroundColor, context) => {
  let backgroundClass;
  let backgroundHex;

  const {
    primaryColor,
    secondaryColor,
    tertiaryColor,
    primaryColorBackgroundClass,
    secondaryColorBackgroundClass,
    tertiaryColorBackgroundClass,
  } = context;

  switch (backgroundColor) {
    case WHITE:
      backgroundClass = styles.colorWhiteBackground;
      backgroundHex = COLOR_WHITE;
      break;
    case PRIMARY:
      backgroundClass = primaryColorBackgroundClass;
      backgroundHex = primaryColor;
      break;
    case SECONDARY:
      backgroundClass = secondaryColorBackgroundClass;
      backgroundHex = secondaryColor;
      break;
    case TERTIARY:
      backgroundClass = tertiaryColorBackgroundClass;
      backgroundHex = tertiaryColor;
      break;
    default:
      backgroundClass = primaryColorBackgroundClass;
      backgroundHex = primaryColor;
      break;
  }

  return { backgroundClass, backgroundHex };
};
